import {
  ALL_CATEGORIES,
  type DebugCategory,
  useDebugStore,
} from './debug-store';

export function installConsoleApi(): void {
  const g = globalThis as Record<string, unknown>;

  g.setDebug = (arg: boolean | string) => {
    const store = useDebugStore.getState();
    if (typeof arg === 'boolean') {
      if (arg) store.enableAll();
      else store.disableAll();
      // eslint-disable-next-line no-console
      console.log(`[debug] all categories ${arg ? 'enabled' : 'disabled'}`);
      return;
    }
    if (typeof arg === 'string') {
      store.disableAll();
      const names = arg.split(',').map((s) => s.trim());
      for (const name of names) {
        if (ALL_CATEGORIES.includes(name as DebugCategory)) {
          store.setCategory(name as DebugCategory, true);
        }
      }
      // eslint-disable-next-line no-console
      console.log(`[debug] enabled: ${names.join(', ')}`);
    }
  };

  g.debugStatus = (): string => {
    const summary = useDebugStore.getState().statusSummary();
    // eslint-disable-next-line no-console
    console.log(summary);
    return summary;
  };
}

export function uninstallConsoleApi(): void {
  const g = globalThis as Record<string, unknown>;
  delete g.setDebug;
  delete g.debugStatus;
}
